import ApiNotifications from '@/api/apiNotifications'
import Vue from 'vue'
import router from '../router'
import { createActionHelpers } from 'vuex-loading'

const { startLoading, endLoading } = createActionHelpers({
  moduleName: 'loading'
})

const state = {
    notificationTeamsFilter:[],
    notificationSportPlacesFilter:[],
    notificationTournamentsFilter:[],

}

const actions = {
    loadNotificationsFilters(context) {
        startLoading(context.dispatch, 'loading filters')
        ApiNotifications.loadFilters((response) => {
            context.commit('updateNotificationsFilters', response.data.data)
            endLoading(context.dispatch, 'loading filters')
        }, error => {
            console.log('Error', error)
            endLoading(context.dispatch, 'loading filters')
        })
    },
    sendNotifications(context, data) {
        startLoading(context.dispatch, 'send notifications')
        ApiNotifications.sendNotifications(data.teamsids, data.msg, data.onlyAdmins,(response) => {
            endLoading(context.dispatch, 'send notifications')
            console.log(response)
        }, error => {
            endLoading(context.dispatch, 'send notifications')
            console.log('Error', error)
        })
    }
}

const mutations = {
    updateNotificationsFilters(state, filters) {
      //  state.notificationsFilters.sportPlaces = filters.sport_places || [{id:-1,name:"",tournaments:[]}]

        var teamswhitoutactivetorunament = false
        for(var i in filters.teams){
          var team = filters.teams[i]
          team.selected = false
          if(!team.active_tournament_id){
            team.active_tournament_id = -1
            teamswhitoutactivetorunament = true
          }
        }

        for(var i in filters.tournaments){
           filters.tournaments[i].selected = false
        }
        state.notificationTournamentsFilter = filters.tournaments
        state.notificationTeamsFilter = filters.teams
        state.notificationSportPlacesFilter = filters.sport_places || []

    }
}

const getters = {

    notificationTeamsFilter(state){
      return state.notificationTeamsFilter
    },
    notificationSportPlacesFilter(state){
      return state.notificationSportPlacesFilter
    },
    notificationTournamentsFilter(state){
      return state.notificationTournamentsFilter
    }
}

export default {
    state,
    actions,
    mutations,
    getters
}



// WEBPACK FOOTER //
// ./src/store/notifications.js